import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { atpProvidersOptions, frontendOptions, insideClinicOptions, outsideClinicOptions } from "../../../../lib/systemData";
import CheckboxCell from "../../../common/interactive/CheckboxCell";
import CustomSelect from "../../../common/interactive/CustomSelect";
import DatepickerWithLabel from "../../../common/interactive/DatepickerWithLabel";
import InputBox from "../../../common/interactive/InputBox";
import { serviceAlreadyexistsOnOtherWorkersComp } from "../../../../lib/script";
import { caseQuickUpdate } from "../../../../lib/fetchApi";
import { notificationActions } from "../../../../store/notifications";
import { caseActions } from "../../../../store/case";

import classes from './WorkersCompDepartments.module.css'

export default function WorkersCompDrawerServiceItem({serviceItem, departmentId, workerCompData}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [workersCompDepartmentServiceItem, setWorkersCompDepartmentServiceItem] = useState(null)
    const [itemIsDisabled, setItemIsDisabled] = useState(false)
    const statusOptionsData = useMemo(() => frontendOptions()?.statusOptions || [], [])
    const insideClinicOptionsData = useMemo(() => insideClinicOptions(), [])
    const outsideClinicOptionsData = useMemo(() => outsideClinicOptions(), [])
    const atpProviderOptionsData = useMemo(() => atpProvidersOptions(), [])

    useEffect(() => {
        if (workerCompData.worker_comp_departments) {
            
            let specificDepartment = workerCompData.worker_comp_departments.find(item => item.department_id == departmentId)

            if (specificDepartment && specificDepartment.services && specificDepartment.services.length > 0 && specificDepartment.services.find(item => item.service_id == serviceItem.id)) {      

                setWorkersCompDepartmentServiceItem(specificDepartment.services.find(item => item.service_id == serviceItem.id))
            } else {
                setWorkersCompDepartmentServiceItem(null)
            }
        }

        setItemIsDisabled(serviceAlreadyexistsOnOtherWorkersComp(workerCompData.id, activeCase, departmentId, serviceItem.id))
        
        
    }, [activeCase, workerCompData.worker_comp_departments, departmentId])

    async function updateHandler(data) {
        // first need to verify that the department exists!!!! If not, need to create one the properly update the services in real time        
        let specificDepartment = workerCompData.worker_comp_departments.find(item => item.department_id == departmentId)

        if (!specificDepartment) { // create department
            let departmentreqBody = {
                type: 'case_worker_comp_departments',
                type_id: data.identifier.type_id, // same as below
                fields: {
                    department_id: departmentId,
                }
            }
    
            let update = await caseQuickUpdate(userToken, activeCase.case.id, departmentreqBody)
    
            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else {            
    
                let dispatchObj = {
                    folder: data.identifier.folder,
                    itemId: data.identifier.type_id,
                    departmentId: data.identifier.department_id,
                    data: update
                }
        
        
                dispatch(caseActions.setDepartmentOnWorkersComp(dispatchObj))
            } 
        } 

        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                department_id: data.identifier.department_id,
                service_id: data.identifier.service_id,
                [data.identifier.field] : data.data.value,
            }
        }

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {  

            let dispatchObj = {
                folder: data.identifier.folder,
                itemId: data.identifier.type_id,
                departmentId: data.identifier.department_id,
                serviceId: data.identifier.service_id,
                data: update
            }    
   
            dispatch(caseActions.setServiceOnWorkersComp(dispatchObj))
        }  
    }



    return <tr className={`${itemIsDisabled ? classes.item_disabled : ''}`}>                        
        <td>{serviceItem.description}</td>

        {(departmentId == 1 || departmentId == 2) && <td >
            <InputBox currentValue={workersCompDepartmentServiceItem?.no_visits} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_services', field: 'no_visits', type_id: workerCompData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'worker_comps'}}/>
        </td>}
        <td>
            <DatepickerWithLabel textRight={true} defaultDate={workersCompDepartmentServiceItem?.request_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_services', field: 'request_date', type_id: workerCompData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'worker_comps'}}/>
        </td>
        <td className="table-cell-no-padding">
            <CustomSelect optionsData={statusOptionsData} preSelectedValue={workersCompDepartmentServiceItem?.status_id} action={updateHandler} identifier={{type: 'case_worker_comp_dep_services', field: 'status_id', type_id: workerCompData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'major_meds'}} sameSizeAsContainer={true}/>
        </td>
        <td>
            <DatepickerWithLabel textRight={true} defaultDate={workersCompDepartmentServiceItem?.auth_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_services', field: 'auth_date', type_id: workerCompData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'worker_comps'}}/>
        </td>
        <td>
            <DatepickerWithLabel textRight={true} defaultDate={workersCompDepartmentServiceItem?.auth_exp_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_worker_comp_dep_services', field: 'auth_exp_date', type_id: workerCompData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'worker_comps'}}/>
        </td>
        <td>            
            <CheckboxCell checked={workersCompDepartmentServiceItem?.is_outside_clinic} action={updateHandler} identifier={{type: 'case_worker_comp_dep_services', field: 'is_outside_clinic', type_id: workerCompData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'worker_comps'}} setStyle={'centered'}/>
        </td>


        {/* clinic need to have different options outside/ not outside same as on service tab  */}
        <td className="table-cell-no-padding">
            {(!workersCompDepartmentServiceItem || !workersCompDepartmentServiceItem.is_outside_clinic || workersCompDepartmentServiceItem.is_outside_clinic == 0) && <CustomSelect optionsData={insideClinicOptionsData} preSelectedValue={workersCompDepartmentServiceItem?.practice_id} action={updateHandler} identifier={{type: 'case_worker_comp_dep_services', field: 'practice_id', type_id: workerCompData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'worker_comps'}} sameSizeAsContainer={true}/>}
            {(workersCompDepartmentServiceItem && (workersCompDepartmentServiceItem.is_outside_clinic == 1 || workersCompDepartmentServiceItem.is_outside_clinic == true)) && <CustomSelect optionsData={outsideClinicOptionsData} preSelectedValue={workersCompDepartmentServiceItem?.outside_location_id} action={updateHandler} identifier={{type: 'case_worker_comp_dep_services', field: 'outside_location_id', type_id: workerCompData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'worker_comps'}} sameSizeAsContainer={true}/>}
        </td>


        {/* provider need to have different options outside/ not outside same as on service tab  */}
        <td className="table-cell-no-padding">
            {(!workersCompDepartmentServiceItem || !workersCompDepartmentServiceItem.is_outside_clinic || workersCompDepartmentServiceItem.is_outside_clinic == 0) && <CustomSelect optionsData={atpProviderOptionsData} preSelectedValue={workersCompDepartmentServiceItem?.provider_id} action={updateHandler} identifier={{type: 'case_worker_comp_dep_services', field: 'provider_id', type_id: workerCompData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'major_meds'}} sameSizeAsContainer={true}/>}
            {(workersCompDepartmentServiceItem && ( workersCompDepartmentServiceItem.is_outside_clinic == 1 || workersCompDepartmentServiceItem.is_outside_clinic == true)) && <InputBox currentValue={workersCompDepartmentServiceItem?.outside_provider} action={updateHandler} identifier={{type: 'case_worker_comp_dep_services', field: 'outside_provider', type_id: workerCompData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'worker_comps'}} setStyle={'simple'}/>}
        </td>
    </tr>
}